'use client';

import React, { useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

interface QueryProviderProps {
  children: React.ReactNode;
}

export default function QueryProvider({ children }: QueryProviderProps) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 5 * 60 * 1000, // 5 minutos
            gcTime: 5 * 60 * 1000, // 5 minutos
            retry: 2,
            refetchOnWindowFocus: false,
          },
        },
      })
  );

  return (
    <QueryClientProvider data-component-id="src/components/providers/QueryProvider.tsx:27:4" data-component-path="src/components/providers/QueryProvider.tsx" data-component-line="27" data-component-file="QueryProvider.tsx" data-component-name="QueryClientProvider" data-component-content="%7B%22elementName%22%3A%22QueryClientProvider%22%7D" client={queryClient}>
      {children}
      <ReactQueryDevtools data-component-id="src/components/providers/QueryProvider.tsx:29:6" data-component-path="src/components/providers/QueryProvider.tsx" data-component-line="29" data-component-file="QueryProvider.tsx" data-component-name="ReactQueryDevtools" data-component-content="%7B%22elementName%22%3A%22ReactQueryDevtools%22%7D" initialIsOpen={false} />
    </QueryClientProvider>
  );
}
